import React, { useEffect, useState } from "react";
import { useLogin } from "../context/LoginContext";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase/client";
import "chart.js/auto";
import { Doughnut, Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

import TitleBox from "../components/common/TitleBox";
import ContainerBox from "../components/common/ContainerBox";
import Modal from "../components/common/Modal";
import Loading from "../components/common/Loading";

const DashboardPage = () => {
  const [loading, setLoading] = useState(false);
  const [modalTable, setModalTable] = useState(false);
  const [checkOutTime, setcheckOutTime] = useState(false);
  const [allProcess, setAllProcess] = useState(null);
  const [filterProcess, setFilterProcess] = useState([]);
  const [counterYears, setCounterYears] = useState(null);
  const [counterType, setCounterType] = useState(null);
  const [counterTypeJrd, setCounterTypeJrd] = useState(null);
  const [counterTypeProcess, setCounterTypeProcess] = useState(null);
  const [counterStage, setCounterStage] = useState(null);
  const [counterPays, setCounterPays] = useState(null);
  const [chartOptions, setChartOptions] = useState(null);
  const [userId, setUserId] = useState(null);
  const [statusInput, setStatusInput] = useState("EN TRAMITE");
  const [secretarioInput, setSecretarioInput] = useState("TODO");
  const [expiration, setExpiration] = useState([]);
  const [escritos, setEscritos] = useState([]);
  const [secretarios, setSecretarios] = useState([]);
  const [payExpiration, setPayExpiration] = useState([]);
  const navigate = useNavigate();
  const { getSessionAuth } = useLogin();

  useEffect(() => {
    const sessionAuth = async () => {
      const session = await getSessionAuth();
      if (session) {
        setUserId(session?.id);
        const userSession = await getUserData(session?.id);
        const dataProcess = await getProcessData(userSession?.dni);
        setAllProcess(dataProcess);
        filterProcessByFilter(dataProcess, statusInput, secretarioInput);
      } else {
        navigate("/login", { replace: true });
      }
    };
    sessionAuth();
  }, []);

  useEffect(() => {
    getSecretarios();
    countYearProcess();
    countTypeArbitration();
    countTypeJrd();
    filterDateExpiration();
    filterDateExpirationEscritos();
    countStatusProcess();
    countTypeProcess();
    countPayProcess();
    filterPayExpiration();
  }, [filterProcess]);

  const getUserData = async (id) => {
    try {
      const { data, error } = await supabase
        .from("users")
        .select("*")
        .eq("id", id)
        .single();
      if (error) {
        console.log(error);
        return;
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const getSecretarios = async () => {
    try {
      const { data, error } = await supabase
        .from("secretaries")
        .select(`users(*)`);
      if (error) {
        console.log(error);
        return;
      }
      setSecretarios(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getProcessData = async (dni) => {
    setLoading(true);
    const dniData =
      dni !== null
        ? "https://arbitrajeccia.com.pe/sistema/restprocess/" + dni
        : "https://arbitrajeccia.com.pe/sistema/restprocess/";
    const result = await fetch(dniData)
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        return data.data;
      });
    return result;
  };

  const countYearProcess = () => {
    if (filterProcess?.length > 0) {
      const yearLabel = filterProcess.map(
        (item) => item.numero_expediente_anio
      );
      const countByYear = yearLabel.reduce((acc, year) => {
        acc[year] = (acc[year] || 0) + 1;
        return acc;
      }, {});
      setCounterYears({
        labels: Object.keys(countByYear),
        datasets: [
          {
            label: "Cantidad de procesos",
            data: Object.values(countByYear),
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)",
            ],
            borderColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
            ],
            borderWidth: 1,
          },
        ],
      });
      setChartOptions({
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: "top",
          },
          datalabels: {
            display: true,
            color: "black",
            formatter: (value, context) => {
              const label = context.chart.data.labels[context.dataIndex];
              return label ? Math.round(value) : "";
            },
          },
        },
      });
    }
  };

  const countTypeArbitration = () => {
    if (filterProcess.length > 0) {
      const unico = filterProcess.filter(
        (trib) => trib.tribunal === "Arbitro unico"
      ).length;
      const colegiado = filterProcess.filter(
        (trib) => trib.tribunal === "Colegiado"
      ).length;
      setCounterType({
        labels: ["Arbitro unico", "Colegiado"],
        datasets: [
          {
            label: "Cantidad de procesos",
            data: [unico, colegiado],
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
            ],
            borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
            borderWidth: 1,
          },
        ],
      });
    }
  };

  const countTypeJrd = () => {
    if (filterProcess.length > 0) {
      const unico = filterProcess.filter(
        (trib) => trib.tribunal === "Adjudicador unico"
      ).length;
      const colegiado = filterProcess.filter(
        (trib) => trib.tribunal === "JRD Colegiada"
      ).length;
      setCounterTypeJrd({
        labels: ["Adjudicador unico", "JRD Colegiada"],
        datasets: [
          {
            label: "# Miembros de JRD",
            data: [unico, colegiado],
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
            ],
            borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
            borderWidth: 1,
          },
        ],
      });
    }
  };

  const countStatusProcess = () => {
    if (filterProcess.length > 0) {
      const stageLabel = filterProcess.map((item) => item.etapa);
      const countByStage = stageLabel.reduce((acc, stage) => {
        acc[stage] = (acc[stage] || 0) + 1;
        return acc;
      }, {});
      setCounterStage({
        labels: Object.keys(countByStage),
        datasets: [
          {
            label: "Cantidad de procesos",
            data: Object.values(countByStage),
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)",
            ],
            borderColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
            ],
            borderWidth: 1,
          },
        ],
      });
    }
  };

  const countTypeProcess = () => {
    if (filterProcess.length > 0) {
      const publico = filterProcess.filter(
        (tipo) => tipo.tipo_proc === "Publico"
      ).length;
      const privado = filterProcess.filter(
        (tipo) => tipo.tipo_proc === "Privado"
      ).length;
      setCounterTypeProcess({
        labels: ["Publico", "Privado"],
        datasets: [
          {
            label: "Cantidad de procesos",
            data: [publico, privado],
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
            ],
            borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
            borderWidth: 1,
          },
        ],
      });
    }
  };

  const countPayProcess = () => {
    if (filterProcess.length > 0) {
      const payLabel = filterProcess.map((item) => item.estado_pago);
      const countByPay = payLabel.reduce((acc, pay) => {
        acc[pay] = (acc[pay] || 0) + 1;
        return acc;
      }, {});
      setCounterPays({
        labels: Object.keys(countByPay),
        datasets: [
          {
            label: "Cantidad de procesos",
            data: Object.values(countByPay),
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)",
            ],
            borderColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
            ],
            borderWidth: 1,
          },
        ],
      });
    }
  };

  const filterDateExpiration = () => {
    if (filterProcess.length > 0) {
      const dateFilter = filterProcess.filter(
        (fecha) => new Date(fecha.fecha_vencimiento_seg) >= new Date()
      );
      dateFilter.sort(
        (a, b) =>
          new Date(a.fecha_vencimiento_seg) - new Date(b.fecha_vencimiento_seg)
      );
      setExpiration(dateFilter);
    }
  };

  const isHoliday = async (date) => {
    const holiday = await fetch(
      "https://www.arbitrajeccia.com.pe/sistema/api/send_holidays.php"
    )
      .then((response) => response.json())
      .then((data) => {
        return data.festividades;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    return holiday.some((festividad) => festividad.fecha === date);
  };

  const filterDateExpirationEscritos = async (checkOutTime = false) => {
    if (filterProcess.length > 0) {
      const escritosSeleccionados = [];
      const diasNoLaborables = [0];

      filterProcess.forEach((registro) => {
        if (registro.escritos.length > 0) {
          registro.escritos.forEach((escrito) => {
            let fechaEntrega = new Date(escrito.fecha_entrega);
            let fechaEmision = new Date(escrito.fecha_emision);

            fechaEntrega.setDate(fechaEntrega.getDate() + 3);

            if (
              isHoliday(fechaEntrega.toISOString().split("T")[0]) ||
              diasNoLaborables.includes(fechaEntrega.getDay())
            ) {
              fechaEntrega.setDate(fechaEntrega.getDate() + 1);
            }

            if (isNaN(fechaEmision.getTime()) || fechaEmision > fechaEntrega) {
              escrito.plazo = "OUT";
            } else {
              escrito.plazo = "IN";
            }
            escritosSeleccionados.push({
              expediente: registro.expediente,
              escrito: escrito,
            });
          });
        }
      });

      if (escritosSeleccionados.length > 0) {
        const filter = checkOutTime
          ? escritosSeleccionados.filter(
              (seleccion) => seleccion.escrito.plazo === "OUT"
            )
          : escritosSeleccionados;
        setEscritos(filter);
      } else {
        setEscritos([]);
      }
    }
  };

  const filterPayExpiration = () => {
    if (filterProcess.length > 0) {
      const dateFilter = filterProcess.filter(
        (fecha) => fecha.estado_pago === "Pendiente"
      );
      setPayExpiration(dateFilter);
    }
  };

  const handleChangeFilter = (event) => {
    const filter = event.target.value;
    filterProcessByFilter(allProcess, filter, secretarioInput);
    setStatusInput(filter);
  };

  const handleChangeFilterSecretarios = (event) => {
    const dniSecretario = event.target.value;
    filterProcessByFilter(allProcess, statusInput, dniSecretario);
    setSecretarioInput(dniSecretario);
  };

  const filterProcessByFilter = (data, status, dni) => {
    if (status === "" && dni === "TODO") {
      setFilterProcess(data);
    }
    if (status === "" && dni !== "TODO") {
      const dataFilter = data.filter(
        (process) => process.dni_secretario === dni
      );
      setFilterProcess(dataFilter);
    }
    if (status !== "" && dni === "TODO") {
      const dataFilter = data.filter((process) => process.estado === status);
      setFilterProcess(dataFilter);
    }
    if (status !== "" && dni !== "TODO") {
      const dataFilter = data.filter(
        (process) => process.estado === status && process.dni_secretario === dni
      );
      setFilterProcess(dataFilter);
    }
  };

  function limpiarTexto(texto) {
    if (texto === null) return "";
    var regex = /<[^>]*>/g;
    texto = texto.replace(regex, "");

    var replacements = {
      "&aacute;": "á",
      "&eacute;": "é",
      "&iacute;": "í",
      "&oacute;": "ó",
      "&uacute;": "ú",
      "&ntilde;": "ñ",
      "&Aacute;": "Á",
      "&Eacute;": "É",
      "&Iacute;": "Í",
      "&Oacute;": "Ó",
      "&Uacute;": "Ú",
      "&Ntilde;": "Ñ",
    };

    for (var key in replacements) {
      texto = texto.replace(new RegExp(key, "g"), replacements[key]);
    }
    return texto;
  }

  return (
    <div className="pb-5">
      {loading && <Loading />}
      <TitleBox title="DASHBOARD - SEGUIMIENTO DE PROCESOS" />
      <div className="flex justify-start items-center gap-4">
        <select
          className={`text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 mb-4 text-center inline-flex items-center gap-1`}
          onChange={(e) => handleChangeFilter(e)}
          defaultValue={statusInput}
        >
          <option value="">Todo</option>
          <option value={"EN TRAMITE"}>En Trámite</option>
        </select>
        {userId === "ba161775-fb66-40b1-b2cc-cd03c681cded" && (
          <select
            className={`text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 mb-4 text-center inline-flex items-center gap-1`}
            onChange={(e) => handleChangeFilterSecretarios(e)}
          >
            <option value="TODO">Secretarios</option>
            {secretarios.map((secretario) => (
              <option key={secretario.users.id} value={secretario.users.dni}>
                {secretario.users.first_name} {secretario.users.last_name}
              </option>
            ))}
          </select>
        )}
        <button
          type="button"
          className={`text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 mb-4 text-center inline-flex items-center gap-1`}
          onClick={() => setModalTable(true)}
        >
          Ver tabla
        </button>
      </div>
      <div className="grid grid-cols-3 gap-5">
        <ContainerBox>
          <h4 className="text-sm uppercase font-medium">Procesos asignados</h4>
          {counterYears && (
            <Doughnut
              data={counterYears}
              plugins={[ChartDataLabels]}
              options={chartOptions}
              className="w-full"
            />
          )}
        </ContainerBox>
        <div className="col-span-2 flex">
          <ContainerBox>
            <h4 className="text-sm uppercase font-medium">
              Procesos próximos a vencer
            </h4>
            <table>
              <thead>
                <tr>
                  <th className="text-left">Expediente</th>
                  <th className="text-left">Fecha de vencimiento</th>
                  <th className="text-left">Comentarios de seguimiento</th>
                </tr>
              </thead>
              <tbody>
                {expiration.map((exp) => (
                  <tr key={exp.iddatos_caso}>
                    <td>{exp.expediente}</td>
                    <td>{exp.fecha_vencimiento_seg}</td>
                    <td>{exp.seguimiento}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ContainerBox>
        </div>
        <div className="col-span-2 flex">
          <ContainerBox>
            <div className="flex justify-between items-center">
              <h4 className="text-sm uppercase font-medium">
                Plazos de respuesta resoluciones
              </h4>
              <label className="border border-primary rounded-md px-2 py-1 box-border flex items-center gap-x-1">
                Mostrar fuera de plazo:
                <input
                  type="checkbox"
                  checked={checkOutTime}
                  onChange={(e) => {
                    setcheckOutTime(e.target.checked);
                    filterDateExpirationEscritos(e.target.checked);
                  }}
                />
              </label>
            </div>
            <div className="max-h-80 overflow-y-scroll scrollbar">
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left">Expediente</th>
                    <th className="text-left">Código escrito</th>
                    <th className="text-left">Sumilla</th>
                    <th className="text-left">Fecha entrega árbitro</th>
                    <th className="text-left">Fecha emisión res.</th>
                  </tr>
                </thead>
                <tbody>
                  {escritos.map((exp, index) => (
                    <tr
                      key={index}
                      className={`${
                        exp.escrito.plazo === "OUT"
                          ? "bg-red-100"
                          : "bg-green-100"
                      }`}
                    >
                      <td>{exp.expediente}</td>
                      <td>{exp.escrito.id}</td>
                      <td>{limpiarTexto(exp.escrito.sumilla)}</td>
                      <td>{exp.escrito.fecha_entrega}</td>
                      <td>{exp.escrito.fecha_emision}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ContainerBox>
        </div>
        <ContainerBox>
          <h4 className="text-sm uppercase font-medium">Tipos de proceso</h4>
          {counterYears && (
            <Bar
              data={counterTypeProcess}
              plugins={[ChartDataLabels]}
              options={chartOptions}
              className="w-full"
            />
          )}
        </ContainerBox>
        <ContainerBox>
          <h4 className="text-sm uppercase font-medium">Tipos de arbitraje</h4>
          {counterYears && (
            <Bar
              data={counterType}
              plugins={[ChartDataLabels]}
              options={chartOptions}
              className="w-full"
            />
          )}
        </ContainerBox>
        <ContainerBox>
          <h4 className="text-sm uppercase font-medium">Tipos de JRD</h4>
          {counterYears && (
            <Bar
              data={counterTypeJrd}
              plugins={[ChartDataLabels]}
              options={chartOptions}
              className="w-full"
            />
          )}
        </ContainerBox>
        <ContainerBox>
          <h4 className="text-sm uppercase font-medium">
            Estados de los procesos llevados
          </h4>
          {counterYears && (
            <Bar
              data={counterStage}
              plugins={[ChartDataLabels]}
              options={chartOptions}
              className="w-full"
            />
          )}
        </ContainerBox>
        <ContainerBox>
          <h4 className="text-sm uppercase font-medium">
            Estado de derechos de pago
          </h4>
          {counterYears && (
            <Doughnut
              data={counterPays}
              plugins={[ChartDataLabels]}
              options={chartOptions}
              className="w-full"
            />
          )}
        </ContainerBox>
        <div className="flex">
          <ContainerBox>
            <h4 className="text-sm uppercase font-medium">
              Procesos con derechos arbitrales pendientes
            </h4>
            <table>
              <thead>
                <tr>
                  <th className="text-left">Expediente</th>
                  <th className="text-left">Estado</th>
                </tr>
              </thead>
              <tbody>
                {payExpiration.map((exp) => (
                  <tr key={exp.iddatos_caso}>
                    <td>{exp.expediente}</td>
                    <td>{exp.estado_pago}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ContainerBox>
        </div>
      </div>
      <Modal
        isOpen={modalTable}
        onClose={() => setModalTable(false)}
        title={"Tabla General"}
      >
        <table className="w-full border text-xs">
          <thead className="border">
            <tr>
              <th className="text-left border p-1">Expediente</th>
              <th className="text-left border p-1">Demandante</th>
              <th className="text-left border p-1">Demandado</th>
              <th className="text-left border p-1">Miembros</th>
              <th className="text-left border p-1">Seguimiento</th>
              <th className="text-left border p-1">Vencimiento</th>
              <th className="text-left border p-1">Observaciones</th>
              <th className="text-left border p-1">Derechos Arbitrales</th>
              <th className="text-left border p-1">Estado derecho</th>
              <th className="text-left border p-1">Tipo proceso</th>
              <th className="text-left border p-1">Tribunal arbitral</th>
              <th className="text-left border p-1">Etapa</th>
            </tr>
          </thead>
          <tbody>
            {filterProcess.map((exp) => (
              <tr key={exp.iddatos_caso}>
                <td className="border p-1">{exp.expediente}</td>
                <td className="border p-1">{exp.demandante}</td>
                <td className="border p-1">{exp.demandado}</td>
                <td className="border p-1">{exp.nompresidente}</td>
                <td className="border p-1">{exp.seguimiento}</td>
                <td className="border p-1">{exp.fecha_vencimiento_seg}</td>
                <td className="border p-1">
                  {limpiarTexto(exp.estado_actual)}
                </td>
                <td className="border p-1">{exp.derechos_arbitrales}</td>
                <td className="border p-1">{exp.estado_pago}</td>
                <td className="border p-1">{exp.tipo_proc}</td>
                <td className="border p-1">{exp.tribunal}</td>
                <td className="border p-1">{exp.etapa}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal>
    </div>
  );
};

export default DashboardPage;
